import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconSortLinear } from '@medifind/icons';
import { useMFModal } from '@medifind/popups';
import { Button } from '@medifind/shared-basic-components';
import styles from './SortByModal.module.scss';

const SortByModal = ({ shape = 'curved', onSortByChange, sortItems = [], sortValue, title, parentContainer, style = {} }) => {
  const { MFModal, openModal, closeModal } = useMFModal();
  const sortInitial = sortItems.find((item) => item.isDefault);

  return (
    <>
      <MFModal title={title} parentContainer={parentContainer} style={style} classes={{ modalBody: styles['modal-body'] }}>
        <div className={styles['sort-by']}>
          {sortItems.map((item) => (
            <SortByModalItem
              key={item.value}
              display={item.display}
              value={item.value}
              onClick={(e) => {
                onSortByChange(
                  sortItems.find((item) => item.value === e.target.value),
                  true,
                );
                closeModal();
              }}
              isActive={item.value === sortValue}
              className={styles['sort-by__item']}
              activeClassName={styles['is-active']}
            />
          ))}
        </div>
      </MFModal>
      <Button
        onClick={openModal}
        focus={'underline'}
        color={'thin-grey-border'}
        label={
          sortInitial && sortInitial?.value !== sortValue ? (
            <>
              Sort by <div className={styles['sort-by__indicator']} />
            </>
          ) : (
            'Sort by'
          )
        }
        type={'box'}
        shape={shape}
        iconBefore={<IconSortLinear />}
        className={classNames(styles['sort-by__button'])}
      />
    </>
  );
};

const SortByModalItem = ({ display, value, onClick, className, activeClassName, isActive, style }) => {
  return (
    <button key={value} value={value} onClick={onClick} className={classNames(className, { [activeClassName]: isActive })}>
      {display}
    </button>
  );
};

SortByModal.propTypes = {
  shape: PropTypes.string,
  onSortByChange: PropTypes.func.isRequired,
  sortItems: PropTypes.array.isRequired,
  sortValue: PropTypes.string,
  title: PropTypes.string,
  parentContainer: PropTypes.string,
  style: PropTypes.object,
};

export { SortByModal as default, SortByModal };
